
import React from 'react';
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";

interface PromptUsageMeterProps {
  usedCount: number;
  limit: number;
  percentUsed: number;
}

const PromptUsageMeter: React.FC<PromptUsageMeterProps> = ({ 
  usedCount, 
  limit, 
  percentUsed 
}) => {
  const isNearLimit = percentUsed > 80 && percentUsed <= 100;
  const isOverLimit = percentUsed >= 100;
  
  // Choose color based on usage
  const getProgressColor = () => {
    if (isOverLimit) return "bg-red-500";
    if (isNearLimit) return "bg-amber-500";
    return "bg-primary";
  };
  
  return (
    <div className="flex flex-col space-y-1 mb-2">
      <div className="flex justify-between items-center text-xs">
        <span className="font-medium">
          Monthly Prompt Usage: {usedCount}/{limit} 
          {isOverLimit && (
            <span className="text-amber-500 dark:text-amber-400 ml-1">
              (Limit exceeded)
            </span>
          )}
        </span>
        
        {isOverLimit && (
          <span className="text-xs text-primary">Upgrade for more</span>
        )}
      </div>
      
      <Progress 
        value={Math.min(percentUsed, 100)} 
        className={cn(
          "h-1.5 bg-gray-200 dark:bg-gray-700",
          "[&>div]:transition-all",
          isOverLimit && "[&>div]:bg-red-500",
          isNearLimit && "[&>div]:bg-amber-500",
          !isNearLimit && !isOverLimit && "[&>div]:bg-primary"
        )}
      />
    </div>
  );
};

export default PromptUsageMeter;
